import { EChartOption } from 'echarts'
import { toHslaString } from 'shared/mappers'
import { getRegionText, getUniqueCountText, getAggregateDollarsText } from './text'
import { getSeriesSettings, getTooltipSettings } from './settings'
import { getVisualMap, getScaleData } from './maps'

export const getFormatter =
    (aggregateDollarsLabel: string, showAggregateTooltip: boolean, uniqueCountLabel: string, showUniqueCountTooltip: boolean, params: { data: { name: string, donorsTooltipValue: number, dollarsTooltipValue: number } }) =>
        `${params.data.name ? getRegionText(params.data.name) : ""}${showUniqueCountTooltip ? getUniqueCountText(uniqueCountLabel, params.data.donorsTooltipValue) : ''}${showAggregateTooltip ? getAggregateDollarsText(aggregateDollarsLabel, params.data.dollarsTooltipValue) : ''}`

const getChartSeriesData = (displayOptions: MapDisplaySettingsOptions, data: ViewMapDataRecord[]) =>
    getScaleData(data, displayOptions.gradientMapSourceType, displayOptions.enableGradientMap, displayOptions.gradientScale)

export const getOption = (map: EchartsMapOptions, displayOptions: MapDisplaySettingsOptions, data: ViewMapDataRecord[]): EChartOption => ({
    backgroundColor: toHslaString(displayOptions.backgroundColor),
    visualMap: getVisualMap(
        displayOptions.fillColor,
        displayOptions.defaultColor,
        displayOptions.enableGradientMap,
        displayOptions.breakpoints,
        displayOptions.enableBreakpointMap,
        displayOptions.gradientScale,
        displayOptions.gradientMapSourceType,
        displayOptions.enableBreakpointLegend,
        displayOptions.legendColor
    ),
    tooltip: getTooltipSettings(
        displayOptions.aggregateDollarsTooltipLabel,
        displayOptions.displayAggregateDollarsTooltip,
        displayOptions.uniqueCountTooltipLabel,
        displayOptions.displayUniqueCountTooltip
    ),
    series: [
        {
            ...getSeriesSettings(displayOptions, map.kind, map.boundingCoords),
            data: getChartSeriesData(displayOptions, data),
        }
    ],
})
